<div class="vc">
  <div #remoteContainer class="remote-grid"></div>

  <div class="center-msg" *ngIf="connecting">Connecting…</div>
  <div class="center-msg" *ngIf="error">{{ error }}</div>
  <div class="center-msg" *ngIf="inCall && !hasRemoteParticipant">Waiting for others to join…</div>

  <div class="local-thumbnail"><video #localVideo autoplay muted playsinline></video></div>

  <div class="controls" *ngIf="inCall">
    <button (click)="toggleMute()" [class.off]="isMuted">{{ isMuted ? '🔇' : '🎤' }}</button>
    <button (click)="toggleCamera()" [class.off]="isCameraOff">{{ isCameraOff ? '🚫' : '📷' }}</button>
    <button (click)="openAdd()">➕</button>
    <button (click)="endCall()" class="end">📞</button>
  </div>

  <div class="add-panel" *ngIf="showAdd">
    <h4>Add people</h4>
    <label *ngFor="let f of friends">
      <input type="checkbox" [checked]="selected.has(f.id)" (change)="toggleSelect(f.id)"> {{ f.name }}
    </label>
    <p *ngIf="loadingFriends">Loading…</p>
      <p *ngIf="!loadingFriends && !friends.length">No friends found</p>
    <div class="row">
      <button (click)="showAdd = false">Close</button>
      <button class="primary" (click)="addSelected()">Invite</button>
    </div>
  </div>
</div>